import Button from "components/elements/Button/Button";
import {
  AutodeskConnectStatus,
  useAutodeskConnect,
} from "lib/hooks/autodesk/useAutodeskConnect";

export default function AutodeskConnectAction(p: {
  workspaceId: number;
  label: string;
  onConnected(): void;
}) {
  const { connect, status, error } = useAutodeskConnect(
    p.workspaceId,
    p.onConnected,
  );

  const isBusy =
    status === AutodeskConnectStatus.Starting ||
    status === AutodeskConnectStatus.Authenticating;

  return (
    <div>
      <Button
        type="button"
        theme="primary-outline"
        slim
        disabled={isBusy}
        onClick={connect}
      >
        {isBusy ? "Waiting for Autodesk..." : p.label}
      </Button>
      {error && <p className="mt-2 text-xs text-error-normal">{error}</p>}
    </div>
  );
}
